import Loading from '../Loading/Loading';
import { GET_FACE_SCAN_URL } from '../../state/mutations/User';
import { IntelliProveStage, intelliproveCallbackOnEvent } from '../../utils/intelliprove/callbackOnIntelliproveEvent';
import { captureException } from '@sentry/react-native';
import { useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { useStores } from '../../hooks/useStores';

const styles = {
  iframe: {
    border: 'none',
    overflow: 'hidden',
    width: '100%',
    height: '100%',
  },
};



interface IntelliProveMessage {
  stage: IntelliProveStage;
  data?: { hasResults?: boolean };
}

export const IntelliProve = () => {
  const rootStore = useStores();
  const { language } = rootStore;
  const [getFaceScanUrl, { data, loading }] = useMutation(GET_FACE_SCAN_URL, { fetchPolicy: 'no-cache' });

  useEffect(() => {
    const handleMessage = function (e: MessageEvent<IntelliProveMessage>) {
      // Update store if face scan was successful
      if (e.data?.data?.hasResults) {
        rootStore?.user?.setHasFaceScanResults(true);
      }
      intelliproveCallbackOnEvent(e.data.stage, e.data.data);
    };

    window.addEventListener('message', handleMessage);

    getFaceScanUrl({
      variables: { language: language.language },
      onError: error => {
        console.error(error);
        captureException(error);
      },
    });

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [getFaceScanUrl, language.language, rootStore]);

  if(loading) {
    return <Loading />;
  }

  return data?.url && <iframe src={data.url} id="intelliprove-iframe" allow="camera; fullscreen" style={styles.iframe}></iframe>;
};
